import React, { FC } from 'react';
import Image from 'next/image';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import dynamic from 'next/dynamic';
import HomeSearchSkeleton from '@/components/home/homeSearch/homeSearchSkeleton/HomeSearchSkeleton';
import heromobile from '@/public/images/home/hero/heromobile.webp';
import hero from '@/public/images/home/hero/hero.webp';
const HomeSearch = dynamic(() => import('@/components/home/homeSearch/HomeSearch'), {
  ssr: false,
  loading: HomeSearchSkeleton
});
const Hero: FC = () => {
  return <Box className={'home-first-section'} data-sentry-element="Box" data-sentry-component="Hero" data-sentry-source-file="Hero.tsx">
      <Box className="hero-section" data-sentry-element="Box" data-sentry-source-file="Hero.tsx">
        <Image className={'mobile-hero'} src={heromobile} alt="سایت شب" objectFit="cover" loading="eager" fill priority data-sentry-element="Image" data-sentry-source-file="Hero.tsx" />
        <Image className={'desktop-hero'} src={hero} alt="سایت شب" objectFit="cover" loading="lazy" fill data-sentry-element="Image" data-sentry-source-file="Hero.tsx" />
        <Box className={'overlay'} data-sentry-element="Box" data-sentry-source-file="Hero.tsx"></Box>
      </Box>
      <Box className={'content-wrapper'} data-sentry-element="Box" data-sentry-source-file="Hero.tsx">
        <Box className={'content-header'} data-sentry-element="Box" data-sentry-source-file="Hero.tsx">
          <Typography variant={'headlineM'} color={'neutral_min'} className={'searchbar-title'} data-sentry-element="Typography" data-sentry-source-file="Hero.tsx">
            مقصدتان کجاست؟
          </Typography>
          <Typography component={'h1'} variant={'bodyL'} color={'neutral_min'} className={'searchbar-desc'} data-sentry-element="Typography" data-sentry-source-file="Hero.tsx">
            اجاره آنلاین ویلا، سوئیت و اقامتگاه در شمال و سراسر ایران
          </Typography>
        </Box>
        <HomeSearch data-sentry-element="HomeSearch" data-sentry-source-file="Hero.tsx" />
      </Box>
    </Box>;
};
export default Hero;